// NOVAPAY-116-RC3-R1 / CUSTOMER-R4.5 — compact checkout legal acceptance.
import type { StoreV2Lang } from "./store-v2-locale.js";
import { CheckoutLegalActionCards } from "./legal-action-card-v2.js";
import { customerLegalRevisionLabel } from "./legal-customer-revision-v2.js";

void CheckoutLegalActionCards;

export function CheckoutLegalAcceptance({
  lang,
  onOpenOffer,
  onOpenPrivacy,
}: {
  lang: StoreV2Lang;
  onOpenOffer: () => void;
  onOpenPrivacy: () => void;
}) {
  const revision = customerLegalRevisionLabel(lang);
  return (
    <div className="sv2-legal-acceptance sv2-legal-acceptance-compact" data-testid="sv2-checkout-legal-acceptance">
      <p className="sv2-legal-acceptance-row" data-testid="sv2-checkout-legal-row">
        <span aria-hidden="true">✓ </span>
        {lang === "en" ? (
          <>
            By placing an order you agree to the{" "}
            <button type="button" className="sv2-legal-inline-link" data-testid="sv2-checkout-legal-offer" onClick={onOpenOffer}>
              Public offer
            </button>{" "}
            and the{" "}
            <button type="button" className="sv2-legal-inline-link" data-testid="sv2-checkout-legal-privacy" onClick={onOpenPrivacy}>
              Privacy policy
            </button>
            .
          </>
        ) : (
          <>
            Оформлюючи замовлення, ви погоджуєтесь з{" "}
            <button type="button" className="sv2-legal-inline-link" data-testid="sv2-checkout-legal-offer" onClick={onOpenOffer}>
              Публічною офертою
            </button>{" "}
            та{" "}
            <button type="button" className="sv2-legal-inline-link" data-testid="sv2-checkout-legal-privacy" onClick={onOpenPrivacy}>
              Політикою конфіденційності
            </button>
            .
          </>
        )}
      </p>
      <p className="sv2-muted sv2-legal-acceptance-revision" data-testid="sv2-legal-customer-revision">
        {revision}
      </p>
    </div>
  );
}

export function ConsentGateLegalActions({
  lang,
  onOpenOffer,
  onOpenPrivacy,
  onOpenLegalHub,
}: {
  lang: StoreV2Lang;
  onOpenOffer: () => void;
  onOpenPrivacy: () => void;
  onOpenLegalHub: () => void;
}) {
  return (
    <div className="sv2-consent-legal-actions" data-testid="sv2-consent-legal-actions">
      <button
        type="button"
        className="sv2-about-bento-tile sv2-consent-legal-tile"
        data-testid="sv2-consent-legal-offer"
        onClick={onOpenOffer}
      >
        <span className="sv2-about-bento-icon" aria-hidden="true">
          📄
        </span>
        <strong>{lang === "en" ? "Public offer" : "Публічна оферта"}</strong>
      </button>
      <button
        type="button"
        className="sv2-about-bento-tile sv2-consent-legal-tile"
        data-testid="sv2-consent-legal-privacy"
        onClick={onOpenPrivacy}
      >
        <span className="sv2-about-bento-icon" aria-hidden="true">
          🔒
        </span>
        <strong>{lang === "en" ? "Privacy policy" : "Політика конфіденційності"}</strong>
      </button>
      <button
        type="button"
        className="sv2-about-bento-tile sv2-consent-legal-tile"
        data-testid="sv2-consent-legal-hub"
        onClick={onOpenLegalHub}
      >
        <span className="sv2-about-bento-icon" aria-hidden="true">
          🏪
        </span>
        <strong>{lang === "en" ? "About store & documents" : "Про магазин та документи"}</strong>
      </button>
    </div>
  );
}

/** @deprecated duplicate sentence removed — use ConsentGateLegalActions only. */
export function ConsentGateLegalNotice() {
  return null;
}
